import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
    SavingsOvertimePointDto,
    SavingsOvertimeResponseDto,
} from '../types/ReportSavingsSummarySchema';
import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export interface FetchSavingsOvertimeParams {
    dateFrom: string;
    dateTo: string;
    propertyIds?: string[];
    categoryIds?: string[];
    period?: 'day' | 'week' | 'month';
}

export const fetchSavingsOvertime = createAsyncThunk<
    SavingsOvertimePointDto[],
    FetchSavingsOvertimeParams,
    ThunkConfig<string>
>(
    'reportSavingsSummary/fetchSavingsOvertime',
    async (
        { dateFrom, dateTo, propertyIds, categoryIds, period },
        thunkApi,
    ) => {
        const { extra, rejectWithValue } = thunkApi;
        try {
            const response = await extra.api.post<SavingsOvertimeResponseDto>(
                '/v1/reports/savings-insights/overtime',
                {
                    dateFrom,
                    dateTo,
                    ...(period
                        ? {
                              period,
                          }
                        : {}),
                    ...(propertyIds?.length
                        ? {
                              propertyIds,
                          }
                        : {}),
                    ...(categoryIds?.length
                        ? {
                              categoryIds,
                          }
                        : {}),
                },
            );

            return response.data?.items ?? [];
        } catch (e) {
            return rejectWithValue('error');
        }
    },
);
